import { defineStore } from 'pinia'
import { OCDocTypeOCR, PassportOCRResponse } from '../types/api.types'
import { useApiNew } from '../composables/useApi'

export const useOCRStore = defineStore('ocrStore', {
  state: () => ({}),
  actions: {
    async passportOCR(
      file: File,
      docType: OCDocTypeOCR,
      abortController?: AbortController
    ): Promise<PassportOCRResponse> {
      return await useApiNew().ocrService.passportOCR(file, docType, abortController)
    },
  },
})
